import { render } from "./PracticeBatchesPage.vue?vue&type=template&id=1d0dacba"
import script from "./PracticeBatchesPage.vue?vue&type=script&lang=js"
export * from "./PracticeBatchesPage.vue?vue&type=script&lang=js"

import "./PracticeBatchesPage.vue?vue&type=style&index=0&id=1d0dacba&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__